import { useContext, useEffect, useState } from "react";
import { API_REGIONS, Client } from '@amityco/ts-sdk';

import Messages from "./components/Messages";
import Chat from "./components/Chat";
import NewChat from "./components/NewChat";
import Appointments from "./components/Appointments";

import "./styles.scss";
import { useAppSelector } from "@store";
import { IChannel, listUserChannels } from "src/services/amity";
import { AuthContext } from "src/providers/AuthProvider";

const ChatMessages = () => {
  const [loadingChats, setLoadingChats] = useState<boolean>(false);
  const [amityChannels, setAmityChannels] = useState<IChannel[]>([]);
  const [channel, setChannel] = useState<IChannel | null>(null);
  const { userIdAmity } = useAppSelector(state => state.login)
  const { allUsers, profileId } = useContext(AuthContext);

  const filterChannels = (channels: IChannel[]) => {
    return channels?.filter((channel) => channel.displayName)?.filter((channel, index, self) => index === self.findIndex((c) => c.id === channel.id));
  };

  const getAllChannels = async (id: string) => {
    setLoadingChats(true);
    try {
      await listUserChannels(
        id,
        (channels) => setAmityChannels(filterChannels(channels)),
        () => setLoadingChats(false),
      );
    } catch (error) {
      console.error('Amity:', error);
      setLoadingChats(false);
    }
  }

  useEffect(() => {

    if ((profileId || userIdAmity) && Client.getActiveClient().token?.accessToken) {
      getAllChannels(profileId ? profileId : userIdAmity as string);
    }
  }, [profileId, userIdAmity && Client.getActiveClient().token?.accessToken]);

  const [currentView, setCurrentView] = useState<"list" | "chat" | "newChat" | "appointments">("list");

  const handleOpenMessages = (channel: IChannel) => {
    setChannel(channel);
    setCurrentView("chat");
  }

  const handleBackToList = () => {
    setChannel(null);
    setCurrentView("list");
  }

  const handleNewChat = () => setCurrentView("newChat");

  const handleOpenScheduling = () => setCurrentView("appointments");

  return (
    <div className="chat-sidebar">
      {currentView === "list" &&
        <Messages
          loadingChats={loadingChats}
          channels={amityChannels}
          handleNewChat={handleNewChat}
          handleOpenScheduling={handleOpenScheduling}
          handleOpenMessages={handleOpenMessages}
          handleUpdateChat={() => {
            getAllChannels(profileId ? profileId : userIdAmity as string)
          }}
        />}

      {currentView === 'chat' &&
        <Chat
          userId={profileId}
          channel={channel}
          handleBackToList={handleBackToList}
        />}

      {currentView === "newChat" &&
        <NewChat
          handleBackToList={handleBackToList}
          userId={profileId}
          handleOpenMessages={handleOpenMessages}
          allUsers={allUsers}
          channels={amityChannels}
        />}

      {currentView === "appointments" &&
        <Appointments
          handleBackToList={handleBackToList}
        />}
    </div>
  );
};

export default ChatMessages;
